import React from 'react'

import {
  FormChangeArgs,
  FormChangeContext,
  SelectedCountryContext,
  SelectedStateContext,
} from './context'

type ProviderProps = {
  selectedCountryCode?: string | null
  onChange: (args: FormChangeArgs) => void
  discardChangeCounter?: number
  preselectedState?: string | null
  children: React.ReactNode
}

const Provider: React.FC<ProviderProps> = ({
  onChange,
  selectedCountryCode = null,
  children,
  discardChangeCounter = 0,
  preselectedState = null,
}) => (
  <FormChangeContext.Provider value={{onChange, discardChangeCounter}}>
    <SelectedCountryContext.Provider value={selectedCountryCode}>
      <SelectedStateContext.Provider value={preselectedState}>
        {children}
      </SelectedStateContext.Provider>
    </SelectedCountryContext.Provider>
  </FormChangeContext.Provider>
)

export default Provider
